import type { Timestamp } from "@firebase/firestore-types";

export const accountMemberInvitationsFullPath = "accountMemberInvitations";
export const accountMemberInvitationFullPath = (memberInvitationId: string): string =>
  `${accountMemberInvitationsFullPath}/${memberInvitationId}`;

/**
 * A member added by an account holder, until their own Treezor KYC is validated. They cannot read
 * the account: `accountName` is all they see of it. `syncTreezorUser` then adds them to
 * `account.users` and deletes the invitation.
 */
export type AccountMemberInvitation = {
  accountId: string;
  accountName: string;
  uid: string;
  email: string;
  invitedBy: string;
  createdAt: Timestamp;
  /** Treezor pre-review document of this member's power of attorney for this account. */
  powerOfAttorneyDocumentId?: string;
  onboardingSubmittedAt?: Timestamp;
};
